import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { SmallMessageTileComponent } from './small-message-tile/small-message-tile.component';
import { ActiveUserService } from '../../services/activeuser.service';
import { TopTabsComponent } from '../top-tabs/top-tabs.component';
import { CommonModule } from '@angular/common';
import { ParagraphDirective } from '../../shared/directives/paragraph.directive';
import { Client, Message, PatchMessageStatusBody, MessageStatusEnum } from '../../generated-api-proxy';
import { SmartLinkComponent } from '../smart-link/smart-link.component';
import { CmsTextPipe } from '../../pipes/cms-text.pipe';

@Component({
  selector: 'app-messages',
  standalone: true,
  imports: [NgbAccordionModule, SmallMessageTileComponent, TopTabsComponent, CommonModule, ParagraphDirective, SmartLinkComponent, CmsTextPipe],
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.scss',
})
export class MessagesComponent implements OnInit {

  messages: Message[] | null = null;
  hasMessages = false;

  constructor(private activeUser: ActiveUserService, private client: Client, @Inject(LOCALE_ID) private locale: string) { }

  ngOnInit(): void {
    if (this.activeUser.LoggedIn()) {
      this.getMessages();
    } else {
      this.activeUser.loggedInChanged.subscribe((loggedIn) => {
        if (loggedIn) {
          this.getMessages();
        }
      });
    }
  }

  getMessages() {
    this.client.messages(this.locale, 1).subscribe((messages) => {
      this.messages = messages.result;
      this.hasMessages = true;
      if (this.messages.length)
        this.registerReadMessage(this.messages[0].uuid);
    });
  }

  onItemShown(uuid: string) {
    this.registerReadMessage(uuid);
  }

  registerReadMessage(uuid: string) {
    let messageStatus = new PatchMessageStatusBody();
    messageStatus.status = MessageStatusEnum.Read;
    messageStatus.uuid = uuid;

    this.client.messagesStatus(messageStatus).subscribe(() => {
    });
  }
}
